/* HorrorBoard LDP — shared behavior (section-safe build).
   UI logic unchanged from the approved page; the cart layer talks to the
   REAL Shopify cart (/cart/add.js, /cart.js, /cart/change.js, /checkout).
   The Shopify cart is the source of truth — the custom drawer renders it.
   Cart upsell pricing comes from a REAL Shopify automatic BXGY discount —
   this file never invents prices; it renders what /cart.js returns.
   MEDIA: all fallback URLs point at THIS store's own Shopify Files CDN —
   no external/competitor domains. Sections normally override these via
   their Theme Editor settings (hbDesignsData / hbMediaData / hbBatchData). */
(function(){
  if(window.__hbInit) return; window.__hbInit = 1;

  /* ───────────────── DATA ───────────────── */
  const CDN = 'https://cdn.shopify.com/s/files/1/1011/9063/1787/files/';
  const BOARD_URL = '/products/horror-cutting-serving-board';
  const DESIGNS_FALLBACK = [
    {name:'The Lineup',        img:CDN+'Design_1.jpg?v=1786536677', tag:'The full roster on one board.',            status:{cls:'hot',label:'High demand',pct:78}},
    {name:'Ghostface vs Michael', img:CDN+'Design_2.jpg?v=1786554661', tag:'A standoff you get to keep.',           status:{cls:'ok', label:'In stock',pct:54}},
    {name:'Jason vs Freddy',   img:CDN+'Design_3.jpg?v=1786554661', tag:'The fight fans waited decades for.',       status:{cls:'low',label:'Almost gone',pct:91}},
    {name:'Freddy Krueger',    img:CDN+'Design_4.jpg?v=1786554661', tag:'Sweet dreams. Fat chance.',                status:{cls:'ok', label:'In stock',pct:62}},
    {name:'Michael Myers',     img:CDN+'Design_5.jpg?v=1786554661', tag:'He’s standing right there.',          status:{cls:'ok', label:'Available',pct:47}}
  ];
  const TIERS_FALLBACK = [
    {n:1, name:'One Board',    price:79.00,  compare:119.00, sub:'Your movie-night board',            perks:['Any one of the five designs','Display stand included'], badge:null},
    {n:2, name:'Two Boards',   price:139.00, compare:238.00, sub:'Keep one, gift one',        perks:['Mix any two designs','<b>FREE 2-PC Horror Car Headrest Covers · $25 value</b>','Display stands included'], badge:{txt:'Most Popular',cls:''}},
    {n:3, name:'Three Boards', price:199.00, compare:357.00, sub:'The collector set',          perks:['Mix any three designs','<b>FREE 4-PC Car Headrest Covers · 4 different designs · $50 value</b>','Display stands included'], badge:{txt:'Best Value · Collector Set',cls:'red'}}
  ];
  const MEDIA_FALLBACK = {
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/85a52c7bfb6e43179abfec9441bcc85e.mp4',
    videoPoster: CDN+'process-pouring.png?v=1787012671&width=400',
    badge: 'Hand-poured · Small batch'
  };
  const SET_TITLES = {2:'Two-Board Set', 3:'Three-Board Set — AOV Test'};
  const BUNDLE_VARIANTS = {
    2: [53892889149803],
    3: [53892889182571, 53892889215339]
  };
  const GIFT_VARIANTS = {2:0, 3:0}; /* Free gift is recorded as a line-item property on the bundle (see addToCart), not as a separate cart line */
  const GIFT_INFO = {
    2: {title:'2-PC Horror Car Headrest Covers', bundle:'Included FREE with the 2-board bundle'},
    3: {title:'4-PC Car Headrest Covers · 4 Different Designs', bundle:'Included FREE with the 3-board bundle'}
  };
  const GIFT_IMAGES = {
    2: 'https://cdn.shopify.com/s/files/1/1011/9063/1787/files/S0720b69a6fc64b29a53b84f9fe2576efq_jpg_960x960q75_jpg.jpg?v=1787939462',
    3: 'https://cdn.shopify.com/s/files/1/1011/9063/1787/files/horrorboard-4pc-headrest-covers-four-different-designs_c9dfa195-0f94-4b85-b69b-1a6231051e50.png?v=1787941809'
  };
  const fmt = n => '$' + Number(n).toFixed(2);
  const money = n => {
    const value = Number(n);
    return '$' + (Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2));
  };
  const $ = id => document.getElementById(id);
  const setText = (id,v) => { const el=$(id); if(el) el.textContent = v; };

  function readJson(id, fb){
    const el = $(id); if(!el) return fb;
    try{ const v = JSON.parse(el.textContent); if(v==null) return fb; if(Array.isArray(v)&&!v.length) return fb; return v; }catch(e){ return fb; }
  }
  let DESIGNS = DESIGNS_FALLBACK, TIERS = TIERS_FALLBACK, MEDIA = MEDIA_FALLBACK;
  function variantMap(){ return readJson('hbVariantData', {}); }
  function variantMetaMap(){ return readJson('hbVariantMetaData', {}); }
  function refreshData(){
    DESIGNS = readJson('hbDesignsData', DESIGNS_FALLBACK);
    TIERS   = readJson('hbTiersData', TIERS_FALLBACK);
    MEDIA   = Object.assign({}, MEDIA_FALLBACK, readJson('hbMediaData', {}));
    const catalog = variantMetaMap();
    TIERS = TIERS.map(t => {
      const key = t.n === 1 ? (DESIGNS[0] || {}).name : SET_TITLES[t.n];
      const variant = catalog[key];
      if(!variant) return Object.assign({}, t, {available:true});
      const price = Number(variant.price);
      const compare = Number(variant.compareAtPrice);
      return Object.assign({}, t, {
        price: Number.isFinite(price) ? price : Number(t.price),
        compare: Number.isFinite(compare) && compare > 0 ? compare : Number(t.compare),
        available: variant.available !== false
      });
    });
  }
  function upsellCfg(){
    const el = $('cdUpsell'); if(!el) return null;
    const vid = parseInt(el.dataset.vid, 10);
    if(!vid) return null;
    return { el: el, vid: vid, was: parseFloat(el.dataset.was) || 0, url: el.dataset.url || '' };
  }

  /* ───────────────── STATE (UI selection state; the cart lives in Shopify) ───────────────── */
  const state = {
    design: 0,
    tier: 1,                     // default to the 2-board AOV test tier
    slots: [0, 0, 0],            // design per board slot
    galleryMode: 'img'           // img | video
  };
  let serverCart = null;         // latest /cart.js payload — source of truth
  let isAdding = false;
  function clampState(){
    const m = DESIGNS.length - 1;
    if(!Number.isInteger(state.design) || state.design < 0 || state.design > m) state.design = 0;
    state.slots = state.slots.map(s => Number.isInteger(s) && s >= 0 && s <= m ? s : null);
    while(state.slots.length < Math.max.apply(null, TIERS.map(t=>t.n))) state.slots.push(null);
    if(state.tier > TIERS.length - 1 || state.tier < 0) state.tier = 0;
  }

  /* ───────────────── HERO GALLERY ───────────────── */
  function buildThumbs(){
    const thumbsEl = $('thumbs'); if(!thumbsEl) return;
    let html = DESIGNS.map((d,i)=>`
    <button class="thumb ${i===state.design&&state.galleryMode==='img'?'active':''}" data-thumb="${i}" aria-label="${d.name}">
      <img src="${d.img}&width=180" alt="${d.name}" loading="lazy" width="180" height="180">
    </button>`).join('');
    html += `
    <button class="thumb ${state.galleryMode==='video'?'active':''}" data-thumb="video" aria-label="Workshop video">
      <img src="${MEDIA.videoPoster}" alt="Workshop video" loading="lazy" width="180" height="180">
      <span class="play-ico"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>
    </button>`;
    thumbsEl.innerHTML = html; const vt = thumbsEl.querySelector('[data-thumb="video"]'); if(vt && thumbsEl.firstElementChild && thumbsEl.firstElementChild !== vt){ thumbsEl.firstElementChild.insertAdjacentElement('afterend', vt); }
  }
  function renderGalleryMain(){
    const galleryMain = $('galleryMain'); if(!galleryMain){ buildThumbs(); return; }
    if(state.galleryMode === 'video'){
      galleryMain.innerHTML = `
      <div class="gallery-badge">${MEDIA.badge}</div>
      <video autoplay muted loop playsinline poster="${MEDIA.videoPoster.replace('width=400','width=900')}">
        <source src="${MEDIA.videoSrc}" type="video/mp4">
      </video>`;
    } else {
      const d = DESIGNS[state.design];
      galleryMain.innerHTML = `
      <div class="gallery-badge">${MEDIA.badge}</div>
      <img id="heroImg" src="${d.img}&width=850" alt="${d.name} — horror serving board" width="850" height="848">`;
    }
    buildThumbs();
  }

  /* ───────────────── DESIGN SELECT (5 visible thumbnails — one row) ───────────────── */
  function buildDesignGrid(){
    const dz = $('designSelect'); if(!dz) return;
    const cur = DESIGNS[state.design];
    dz.innerHTML = `
    <div class="dz-row" role="radiogroup" aria-label="Choose a design">
      ${DESIGNS.map((x,i)=>`<button type="button" class="dz ${i===state.design?'on':''}" data-design="${i}" role="radio" aria-checked="${i===state.design}" aria-label="Select ${x.name} design" title="${x.name}">
        <img src="${x.img}&width=180" alt="${x.name}" loading="lazy" width="180" height="180">
      </button>`).join('')}
    </div>
    <div class="dz-meta">
      <span class="dz-name" id="selDesignName">${cur.name}</span>
    </div>`;
  }
  function selectDesign(i, source){
    state.design = i;
    state.slots[0] = i;
    state.galleryMode = 'img';
    renderAll();
    trackBundleEvent('bundle_design_selected', Object.assign(bundleEventData(), {
      slot:1,
      source:source || 'design_picker'
    }));
  }

  /* ───────────────── BUNDLES (hero) ───────────────── */
  function slotSelect(slotIdx, tierIdx){
    const id = 'bundle-' + tierIdx + '-design-' + slotIdx;
    return `<div class="slot"><label for="${id}">Board ${slotIdx+1}</label>
    <select id="${id}" data-slot="${slotIdx}" aria-label="Choose design for Board ${slotIdx+1}">${DESIGNS.map((d,i)=>`<option value="${i}" ${state.slots[slotIdx]===i?'selected':''}>${d.name}</option>`).join('')}</select>
  </div>`;
  }
  function bundleVisuals(t){
    const indexes = t.n === 1 ? [state.design] : state.slots.slice(0, t.n);
    const thumbs = indexes.map((designIndex, thumbIndex)=>{
      const d = DESIGNS[designIndex];
      if(!d) return `<span class="bundle-board-thumb bundle-board-empty" style="z-index:${indexes.length-thumbIndex}" aria-hidden="true">?</span>`;
      return `<span class="bundle-board-thumb" style="z-index:${indexes.length-thumbIndex}"><img src="${d.img}&width=96" alt="" loading="lazy" width="40" height="40"></span>`;
    }).join('');
    if(t.n === 1){
      return `<span class="bundle-visuals bundle-visuals-single" aria-hidden="true"><span class="bundle-board-stack">${thumbs}</span></span>`;
    }
    const giftImg = GIFT_IMAGES[t.n] || GIFT_IMAGES[2];
    const giftVisual = t.n === 3
      ? `<span class="headrest-gift-strip">${[0,1,2,3].map(index=>`<span class="headrest-gift-piece piece-${index+1}"><img src="${giftImg}" alt="" loading="lazy" decoding="async" width="96" height="96"></span>`).join('')}</span>`
      : `<span class="headrest-gift-full"><img src="${giftImg}" alt="" loading="lazy" decoding="async" width="118" height="118"></span>`;
    return `<span class="bundle-visuals bundle-visuals-with-gift" aria-hidden="true">
      <span class="bundle-board-stack">${thumbs}</span>
      <span class="bundle-visual-plus">+</span>
      ${giftVisual}
    </span>`;
  }
  function buildBundles(){
    const bundleList = $('bundleList'); if(!bundleList) return;
    const giftByCount = {
      2: 'FREE 2-PC Horror Car Headrest Covers · $25 value',
      3: 'FREE 4-PC Car Headrest Covers · 4 different designs · $50 value'
    };
    const incrementByCount = {2:'2nd board only $60', 3:'Add the 3rd for $60'};
    bundleList.innerHTML = TIERS.map((t,i)=>{
      const active = i===state.tier;
      const save = Math.round(t.compare - t.price);
      const per = t.price / t.n;
      const primary = `${t.n === 1 ? money(per) : fmt(per)} each · Save $${save}`;
      const benefit = t.n === 1 ? 'Choose 1 design' : `Mix & match any ${t.n} designs`;
      const slots = active ? `<div class="slot-row show">${Array.from({length:t.n},(_,slot)=>slotSelect(slot,i)).join('')}</div>` : '';
      return `<div class="bundle ${active?'active':''} ${t.badge?'has-badge':''}" data-tier="${i}" role="radio" aria-checked="${active}" tabindex="0" aria-label="${t.name}, ${money(t.price)}">
      ${t.badge?`<span class="bundle-badge ${t.badge.cls}">${t.badge.txt}</span>`:''}
      <div class="bundle-top">
        <span class="radio" aria-hidden="true"></span>
        <span class="bundle-copy">
          <span class="bundle-title-row"><span class="bundle-name">${t.name}</span>${incrementByCount[t.n]?`<span class="bundle-increment">${incrementByCount[t.n]}</span>`:''}</span>
          <span class="bundle-meta">${primary}</span>
          <span class="bundle-benefit">${benefit}</span>
          ${giftByCount[t.n]?`<span class="bundle-perk">${giftByCount[t.n]}</span>`:''}
        </span>
        <span class="bundle-price"><span class="bp">${money(t.price)}</span><span class="bw">${money(t.compare)}</span></span>
      </div>
      ${bundleVisuals(t)}
      ${slots}
    </div>`;
    }).join('');
    const summary = $('bundleSummary');
    if(summary){
      const selected = TIERS[state.tier];
      const selectedSave = Math.round(selected.compare - selected.price);
      const summaryGift = {
        2:'FREE 2-PC Horror Car Headrest Covers ($25 value)',
        3:'FREE 4-PC Car Headrest Covers — 4 different designs ($50 value)'
      };
      summary.innerHTML = selected.n===1 ? `<span><strong>Save $${selectedSave}</strong> today</span>` : `<span><strong>Save $${selectedSave}</strong> + ${summaryGift[selected.n]}</span>`;
    }
  }

  /* ───────────────── PRICING + BUNDLE VALIDATION ───────────────── */
  function currentTotal(){ return Number(TIERS[state.tier].price); }
  function currentCompare(){ return Number(TIERS[state.tier].compare); }
  function tierVariantKey(t){
    return t.n === 1 ? ((DESIGNS[state.design] || {}).name || '') : SET_TITLES[t.n];
  }
  function selectedDesignIndexes(t){
    return t.n === 1 ? [state.design] : state.slots.slice(0,t.n);
  }
  function selectedDesignNames(t){
    return selectedDesignIndexes(t).map(index => DESIGNS[index] && DESIGNS[index].name).filter(Boolean);
  }
  function validateBundle(){
    const t = TIERS[state.tier];
    if(!t) return {valid:false,message:'Choose a bundle to continue.',slot:null};
    const indexes = selectedDesignIndexes(t);
    const invalidSlot = indexes.findIndex(index => !Number.isInteger(index) || !DESIGNS[index]);
    if(indexes.length !== t.n || invalidSlot > -1){
      return {valid:false,message:`Choose all ${t.n} design${t.n===1?'':'s'} before adding to cart.`,slot:invalidSlot > -1 ? invalidSlot : 0};
    }
    const key = tierVariantKey(t);
    const id = variantMap()[key];
    if(!id) return {valid:false,message:'This bundle is not configured for checkout yet.',slot:null};
    const meta = variantMetaMap()[key];
    if((meta && meta.available === false) || t.available === false){
      return {valid:false,message:'This selection is currently unavailable.',slot:null};
    }
    return {valid:true,message:'',slot:null};
  }
  function bundleEventData(t){
    const tier = t || TIERS[state.tier];
    return {
      bundle_quantity:tier.n,
      selected_designs:selectedDesignNames(tier),
      price:Number(tier.price),
      savings:Math.round(Number(tier.compare)-Number(tier.price))
    };
  }
  function trackBundleEvent(name, payload){
    const data = Object.assign({event:name}, payload || bundleEventData());
    try{
      if(Array.isArray(window.dataLayer)) window.dataLayer.push(data);
      if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
        window.Shopify.analytics.publish(name, payload || bundleEventData());
      }
    }catch(e){}
  }
  function renderValidation(result, announce){
    const el = $('bundleValidation');
    if(el){
      el.hidden = result.valid;
      el.textContent = result.valid ? '' : result.message;
      if(announce && !result.valid) el.setAttribute('role','alert');
      else el.setAttribute('role','status');
    }
    document.querySelectorAll('#bundleList select[data-slot]').forEach(select => {
      const invalid = !result.valid && result.slot === Number(select.dataset.slot);
      select.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      select.setAttribute('aria-describedby','bundleValidation');
    });
  }
  function setPurchaseState(result){
    ['mainAtc','stickyAtc','finalAtc'].forEach(id => {
      const button = $(id); if(!button) return;
      button.disabled = isAdding || !result.valid;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      button.setAttribute('aria-busy', isAdding ? 'true' : 'false');
    });
  }
  function focusValidation(result){
    if(result.slot === null) return;
    const select = document.querySelector('#bundleList select[data-slot="' + result.slot + '"]');
    if(select) select.focus();
  }
  function selectTier(index, source){
    const changed = state.tier !== index;
    state.tier = index;
    renderAll();
    if(changed) trackBundleEvent('bundle_option_selected', Object.assign(bundleEventData(), {source:source || 'bundle_card'}));
  }

  /* ───────────────── COLLECTION SECTION ───────────────── */
  function buildCollection(){
    const collGrid = $('collGrid'); if(!collGrid) return;
    const catalog = variantMetaMap();
    collGrid.innerHTML = DESIGNS.map((d,i)=>{
      const available = !catalog[d.name] || catalog[d.name].available !== false;
      return `
    <button class="coll-card ${i===state.design?'active':''}" data-coll="${i}">
      <span class="cc-img"><img src="${d.img}&width=600" alt="${d.name}" loading="lazy" width="600" height="600"></span>
      <span class="cc-body">
        <h3>${d.name}</h3>
        <span class="cc-tag">${d.tag}</span>
        <span class="cc-status ${available?'ok':'low'}"><span class="sdot"></span>${available?'Available':'Unavailable'}</span>
      </span>
    </button>`;
    }).join('');
    const btn = $('collBuyBtn'); if(btn) btn.textContent = `Continue with ${DESIGNS[state.design].name} →`;
  }

  /* ───────────────── BATCH BOARD ───────────────── */
  let batchFilled = false;
  function buildBatch(){
    const batchBoard = $('batchBoard'); if(!batchBoard) return;
    const rows = readJson('hbBatchData', DESIGNS.map(d=>({name:d.name, img:d.img})));
    const catalog = variantMetaMap();
    batchBoard.querySelectorAll('.batch-row').forEach(r=>r.remove());
    rows.forEach(d=>{
      const variant = catalog[d.name];
      const available = !variant || variant.available !== false;
      const row = document.createElement('div');
      row.className = `batch-row ${available?'ok':'low'}`;
      row.innerHTML = `
    <img src="${d.img}&width=120" alt="" loading="lazy" width="120" height="120">
    <span class="b-name">${d.name}</span>
    <span class="b-label">${available?'Available':'Unavailable'}</span>`;
      batchBoard.appendChild(row);
    });
  }

  /* ───────────────── TIER SECTION ───────────────── */
  function buildTiers(){
    const tierGrid = $('tierGrid'); if(!tierGrid) return;
    tierGrid.innerHTML = TIERS.map((t,i)=>`
    <div class="tier ${i===state.tier?'active':''} ${i===1?'pop':''}" data-tiercard="${i}">
      ${t.badge?`<span class="tier-badge ${t.badge.cls}">${t.badge.txt}</span>`:''}
      <h3>${t.name}</h3>
      <div class="t-sub">${t.sub}</div>
      <div><span class="t-price">${fmt(t.price)}</span><span class="t-was">${fmt(t.compare)}</span></div>
      <div class="t-save">You save ${fmt(t.compare-t.price)} (${Math.round((1-t.price/t.compare)*100)}%)</div>
      <ul>${t.perks.map(p=>`<li><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span>${p}</span></li>`).join('')}
        <li><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span>Free tracked worldwide shipping</span></li>
      </ul>
      <button class="tier-btn">${i===state.tier?'Selected — Add to Cart':'Choose '+t.name}</button>
    </div>`).join('');
  }

  /* ───────────────── FINAL CTA ───────────────── */
  function buildFinal(){
    const finalThumbs = $('finalThumbs'); if(!finalThumbs) return;
    finalThumbs.innerHTML = DESIGNS.map((d,i)=>`
    <button class="fthumb ${i===state.design?'active':''}" data-final="${i}" aria-label="${d.name}">
      <img src="${d.img}&width=180" alt="${d.name}" loading="lazy" width="180" height="180">
    </button>`).join('');
    setText('finalSelName', DESIGNS[state.design].name);
    const fp = $('finalPrice'); if(fp) fp.innerHTML = `${fmt(TIERS[state.tier].price)} <s>${fmt(TIERS[state.tier].compare)}</s>`;
  }

  /* ───────────────── STICKY BAR + SCROLL EFFECTS ───────────────── */
  function onScrollFx(){
    const vh = window.innerHeight;
    const heroBuy = document.querySelector('.hero-buy');
    const finalSec = document.querySelector('.final');
    const stickyBar = $('stickyBar');
    const batchBoard = $('batchBoard');
    const wvEl = $('workshopVideo');
    if(heroBuy && finalSec && stickyBar){
      const hb = heroBuy.getBoundingClientRect();
      const fs = finalSec.getBoundingClientRect();
      const heroVis = hb.bottom > 90 && hb.top < vh;
      const finalVis = fs.top < vh * .8 && fs.bottom > 0;
      const cd = $('cartDrawer');
      const cartOpen = cd ? cd.classList.contains('open') : false;
      stickyBar.classList.toggle('show', !heroVis && !finalVis && !cartOpen);
    }
    if(!batchFilled && batchBoard){
      const bb = batchBoard.getBoundingClientRect();
      if(bb.top < vh * .85){
        batchFilled = true;
        batchBoard.querySelectorAll('.b-fill').forEach(f=>f.style.width = f.dataset.pct+'%');
      }
    }
    if(wvEl){
      const vr = wvEl.getBoundingClientRect();
      if(vr.top < vh && vr.bottom > 0){ if(wvEl.paused) wvEl.play().catch(()=>{}); }
      else if(!wvEl.paused){ wvEl.pause(); }
    }
  }
  const updateSticky = onScrollFx;
  function videoInit(){
    const wv = $('workshopVideo');
    if(!wv || wv.dataset.hbInit) return; wv.dataset.hbInit = 1;
    const frame = wv.closest('.video-frame');
    wv.addEventListener('canplay', ()=>{ if(frame) frame.classList.remove('fallback'); });
    setTimeout(()=>{ if(wv.readyState < 2 && frame){ frame.classList.add('fallback'); } }, 7000);
  }

  /* ───────────────── REAL SHOPIFY CART ───────────────── */
  const ADD_ERROR = "We couldn't add this item to your cart. Please try again.";
  let giftSyncPromise = null;
  function cartRequest(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(r => { if(!r.ok) throw 0; return r.json(); });
  }
  function cartPost(url, body){
    return fetch(url, {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(body)
    }).then(r => { if(!r.ok) throw 0; return r.json(); });
  }
  function giftTierFor(item){
    const vid = Number(item && item.variant_id);
    if(vid === GIFT_VARIANTS[2]) return 2;
    if(vid === GIFT_VARIANTS[3]) return 3;
    return 0;
  }
  function bundleTierFor(item){
    const vid = Number(item && item.variant_id);
    if(BUNDLE_VARIANTS[2].indexOf(vid) > -1) return 2;
    if(BUNDLE_VARIANTS[3].indexOf(vid) > -1) return 3;
    return 0;
  }
  function syncBundleGifts(cart){
    if(giftSyncPromise) return giftSyncPromise;
    if(!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    const wanted = {2:false, 3:false};
    const gifts = {2:[], 3:[]};
    cart.items.forEach(it => {
      const bundleTier = bundleTierFor(it);
      const giftTier = giftTierFor(it);
      if(bundleTier && it.quantity > 0) wanted[bundleTier] = true;
      if(giftTier) gifts[giftTier].push(it);
    });
    const changes = [];
    const additions = [];
    [2,3].forEach(n => {
      if(!wanted[n]){
        gifts[n].forEach(it => changes.push({id:it.key, quantity:0}));
        return;
      }
      if(!gifts[n].length){
        /* gift is a line-item property on the bundle now; nothing to add here */
        return;
      }
      gifts[n].forEach((it, idx) => {
        const desired = idx === 0 ? 1 : 0;
        if(it.quantity !== desired) changes.push({id:it.key, quantity:desired});
      });
    });
    if(!changes.length && !additions.length) return Promise.resolve(cart);
    let chain = Promise.resolve();
    changes.forEach(change => { chain = chain.then(() => cartPost('/cart/change.js', change)); });
    if(additions.length) chain = chain.then(() => cartPost('/cart/add.js', {items:additions}));
    giftSyncPromise = chain
      .then(() => cartRequest())
      .finally(() => { giftSyncPromise = null; });
    return giftSyncPromise;
  }
  function fetchCart(){
    return cartRequest()
      .then(c => syncBundleGifts(c))
      .then(c => { serverCart = c; renderCart(); return c; })
      .catch(() => { renderCart(); return null; });
  }
  function changeLine(line, quantity){
    cartPost('/cart/change.js', {line:line, quantity:quantity})
      .then(c => syncBundleGifts(c))
      .then(c => { serverCart = c; renderCart(); })
      .catch(() => fetchCart());
  }
  function boardsFor(item){
    const tier = bundleTierFor(item);
    if(tier) return tier;
    if(item.variant_title === SET_TITLES[2]) return 2;
    if(item.variant_title === SET_TITLES[3] || item.variant_title === 'Three-Board Set') return 3;
    return 1;
  }
  function designImg(name){
    const d = DESIGNS.find(x => x.name === name);
    return d ? d.img + '&width=180' : null;
  }

  function addToCart(){
    if(isAdding) return;
    const validation = validateBundle();
    if(!validation.valid){
      renderValidation(validation, true);
      setPurchaseState(validation);
      trackBundleEvent('bundle_validation_error', Object.assign(bundleEventData(), {reason:validation.message}));
      showToast(validation.message);
      focusValidation(validation);
      return;
    }
    const map = variantMap();
    const t = TIERS[state.tier];
    const eventData = bundleEventData(t);
    let baseItems;
    if(t.n > 1){
      const setId = map[SET_TITLES[t.n]];
      const names = selectedDesignNames(t);
      const props = {};
      for(let i=0; i<t.n; i++){ props['Board ' + (i+1)] = names[i]; }
      if(GIFT_INFO[t.n]) props['Free Gift'] = GIFT_INFO[t.n].title + ' (included)'; baseItems = [{id:setId, quantity:1, properties:props}];
    } else {
      const id = map[DESIGNS[state.design].name];
      baseItems = [{id:id, quantity:1}];
    }
    isAdding = true;
    setPurchaseState(validation);
    cartRequest()
      .catch(() => serverCart)
      .then(c => {
        const items = baseItems.slice();
        const giftId = GIFT_VARIANTS[t.n];
        const hasGift = giftId && c && Array.isArray(c.items) && c.items.some(it => Number(it.variant_id) === giftId);
        if(giftId && !hasGift){
          items.push({id:giftId, quantity:1, properties:{'_Bundle Gift For':t.n+'-Board Set'}});
        }
        return cartPost('/cart/add.js', {items:items});
      })
      .then(result => {
        trackBundleEvent('bundle_add_to_cart', eventData);
        return result;
      })
      .then(() => fetchCart())
      .then(c => {
        if(c && c.item_count > 0){
          openCart();
          showToast(t.n > 1 ? 'Bundle + free gift added' : 'Board added to cart');
        }else{
          showToast(ADD_ERROR);
        }
      })
      .catch(() => showToast(ADD_ERROR))
      .finally(() => {
        isAdding = false;
        setPurchaseState(validateBundle());
      });
  }

  function addById(vid, btn, onDone){
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(r => { if(!r.ok) throw 0; return r.json(); })
      .then(() => fetchCart())
      .then(c => {
        if(btn) btn.disabled = false;
        if(c && c.item_count > 0){ openCart(); showToast('Added to cart'); if(onDone) onDone(true); }
        else { showToast(ADD_ERROR); if(onDone) onDone(false); }
      })
      .catch(() => { if(btn) btn.disabled = false; showToast(ADD_ERROR); if(onDone) onDone(false); });
  }

  function addUpsell(){
    const up = upsellCfg(); if(!up) return;
    const btn = $('cdUpsellAdd');
    if(btn){ btn.disabled = true; btn.textContent = '✓ Added'; }
    addById(up.vid, btn, function(ok){
      if(!ok && btn){ const l = btn.dataset.label; if(l) btn.textContent = l; }
    });
  }

  function renderCart(){
    const cartBody = $('cartBody'), cartFoot = $('cartFoot');
    const trust = $('cartTrust'), headSub = $('cdHeadSub');
    const up = upsellCfg();
    const upId = up ? up.vid : 0;
    const items = serverCart && serverCart.items ? serverCart.items : [];
    let boards = 0, upsellQty = 0;
    items.forEach(it => {
      if(it.variant_id === upId){ upsellQty += it.quantity; }
      else if(!giftTierFor(it)){ boards += boardsFor(it) * it.quantity; }
    });
    setText('cartCount', boards + upsellQty);
    if(!cartBody || !cartFoot) return;
    if(trust) trust.style.display = items.length ? '' : 'none';
    if(headSub) headSub.style.display = items.length ? '' : 'none';
    if(up){
      up.el.style.display = (boards > 0 && upsellQty === 0) ? '' : 'none';
      const btn = $('cdUpsellAdd');
      if(btn && upsellQty === 0){ btn.disabled = false; const l = btn.dataset.label; if(l) btn.textContent = l; }
    }
    if(!items.length){
      cartBody.innerHTML = '<div class="cd-empty">Your cart is empty.<br><span class="cd-empty-sub">Pick a nightmare and give your counter something worth staring at.</span><br><button class="cd-empty-btn" id="cdShopBtn">Shop the Boards</button></div>';
      cartFoot.style.display = 'none';
      return;
    }
    let html = '';
    let compareTotal = 0;
    items.forEach((it, idx) => {
      const line = idx + 1;
      const giftTier = giftTierFor(it);
      if(giftTier){
        const info = GIFT_INFO[giftTier];
        const was = it.original_line_price / 100;
        const discounted = it.line_level_total_discount > 0 || it.final_line_price === 0;
        const gimg = it.image ? (it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180') : '';
        compareTotal += was;
        html += `<div class="cd-card cd-card-gift">
      <img class="cdc-img" src="${gimg}" alt="${info.title}">
      <div class="cdc-mid">
        <div class="cdc-name">${discounted?'FREE ':''}${info.title}</div>
        <div class="cdc-chips"><span class="cdc-chip">${info.bundle}</span></div>
      </div>
      <div class="cdc-price"><b>${discounted?'FREE':fmt(it.final_line_price/100)}</b>${discounted?`<s>${fmt(was)}</s>`:''}</div>
    </div>`;
        return;
      }
      if(it.variant_id === upId){
        const was = (up && up.was > 0) ? up.was : (it.original_line_price / 100 / it.quantity);
        compareTotal += was * it.quantity;
        const disc = it.line_level_total_discount / 100;
        const uimg = it.image ? (it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180') : '';
        const uref = up && up.url ? up.url : '';
        html += `<div class="cd-card">
      ${uref?`<a class="cdc-imglink" href="${uref}">`:''}<img class="cdc-img" src="${uimg}" alt="${it.product_title}">${uref?'</a>':''}
      <div class="cdc-mid">
        <div class="cdc-name">${uref?`<a href="${uref}">${it.product_title}</a>`:it.product_title}</div>
        ${disc > 0 ? `<div class="cdc-chips"><span class="cdc-chip">Board bundle − ${fmt(disc)}</span></div>` : ''}
        <div class="cdc-row">
          <button class="ci-remove" data-line="${line}" data-q="0">Remove</button>
        </div>
      </div>
      <div class="cdc-price"><b>${fmt(it.final_line_price/100)}</b><s>${fmt(was * it.quantity)}</s></div>
    </div>`;
        return;
      }
      const n = boardsFor(it);
      const tier = TIERS.find(x => x.n === n) || TIERS[0];
      compareTotal += tier.compare * it.quantity;
      const names = [];
      if(n > 1){
        for(let b=1; b<=n; b++){ names.push((it.properties && it.properties['Board ' + b]) || tier.name); }
      } else {
        names.push(it.variant_title || it.product_title);
      }
      const img = designImg(names[0]) || it.image || MEDIA.videoPoster;
      const giftInfo = n > 1 ? GIFT_INFO[n] : null; if(giftInfo) compareTotal += (n === 2 ? 25 : 50) * it.quantity; const chips = names.map(nm => `<span class="cdc-chip">${nm}</span>`).join('') + (giftInfo ? `<span class="cdc-chip">+ FREE ${giftInfo.title}</span>` : '');
      html += `<div class="cd-card">
      <a class="cdc-imglink" href="${BOARD_URL}"><img class="cdc-img" src="${img}" alt="${names[0]}"></a>
      <div class="cdc-mid">
        <div class="cdc-name"><a href="${BOARD_URL}">Horror Serving Board${n>1?` — ${tier.name}`:''}</a></div>
        <div class="cdc-chips">${chips}</div>
        <div class="cdc-row">
          <div class="qty-ctl"><button data-line="${line}" data-q="${it.quantity-1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-line="${line}" data-q="${it.quantity+1}" aria-label="Increase">+</button></div>
          <button class="ci-remove" data-line="${line}" data-q="0">Remove</button>
        </div>
      </div>
      <div class="cdc-price"><b>${fmt(it.final_line_price/100)}</b><s>${fmt(tier.compare*it.quantity)}</s></div>
    </div>`;
    });
    cartBody.innerHTML = html;
    const sub = serverCart.items_subtotal_price / 100;
    const total = serverCart.total_price / 100;
    setText('cdSubtotal', fmt(sub));
    setText('cdSaved', '− ' + fmt(Math.max(0, compareTotal - sub)));
    setText('cdTotal', fmt(total));
    const co = $('cdCheckout');
    if(co) co.innerHTML = `<svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>Secure Checkout — ${fmt(total)}`;
    cartFoot.style.display = 'block';
  }

  function openCart(){ const d=$('cartDrawer'), o=$('cartOverlay'); if(!d||!o) return; d.classList.add('open'); o.classList.add('open'); updateSticky(); fetchCart(); }
  function closeCart(){ const d=$('cartDrawer'), o=$('cartOverlay'); if(!d||!o) return; d.classList.remove('open'); o.classList.remove('open'); updateSticky(); }

  function checkout(){
    fetchCart()
      .then(c => {
        if(c && c.item_count > 0){ window.location.href = '/checkout'; }
        else { renderCart(); showToast(ADD_ERROR); }
      })
      .catch(() => showToast(ADD_ERROR));
  }

  /* ───────────────── TOAST ───────────────── */
  let toastTimer;
  function showToast(msg){
    const t = $('toast'); if(!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(()=>t.classList.remove('show'), 2200);
  }

  /* ───────────────── MASTER RENDER ───────────────── */
  function renderAll(){
    refreshData();
    clampState();
    const d = DESIGNS[state.design];
    const t = TIERS[state.tier];
    renderGalleryMain();
    buildDesignGrid();
    buildBundles();
    buildCollection();
    buildTiers();
    buildFinal();
    const result = validateBundle();
    const amount = money(currentTotal());
    const ctaLabel = `ADD ${t.n} ${t.n===1?'BOARD':'BOARDS'} TO CART — ${amount}`;
    setText('selDesignName', d.name);
    setText('priceNow', amount);
    setText('priceWas', money(currentCompare()));
    setText('saveChip', 'Save ' + Math.round((1-currentTotal()/currentCompare())*100) + '%');
    setText('mainAtc', ctaLabel);
    setText('finalAtc', ctaLabel);
    setText('stickyAtc', `ADD ${t.n} — ${amount}`);
    const si = $('stickyImg'); if(si) si.src = d.img + '&width=180';
    setText('stickyName', t.n>1 ? `${t.name} · ${selectedDesignNames(t).join(' + ')}` : d.name);
    setText('stickyNow', amount);
    setText('stickyWas', money(currentCompare()));
    const available = result.valid || result.message.indexOf('unavailable') === -1;
    setText('stockIn', available ? 'In stock' : 'Unavailable');
    const stockRest = $('stockRest');
    if(stockRest) stockRest.hidden = !available;
    const stockDot = $('stockDot');
    if(stockDot) stockDot.classList.toggle('is-unavailable', !available);
    renderValidation(result, false);
    setPurchaseState(result);
  }

  /* ───────────────── EVENTS (delegated once at document level) ───────────────── */
  document.addEventListener('click', function(e){
    let t;
    if(e.target.closest('#navCartBtn')){ openCart(); return; }
    if(e.target.closest('#cartClose')){ closeCart(); return; }
    if(e.target.closest('#cdContinue') || e.target.closest('#cdShopBtn')){ closeCart(); return; }
    if(e.target.closest('#cartOverlay')){ closeCart(); return; }
    const purchaseButton = e.target.closest('#mainAtc, #stickyAtc, #finalAtc');
    if(purchaseButton){
      if(purchaseButton.getAttribute('aria-disabled') === 'true'){ e.preventDefault(); return; }
      addToCart();
      return;
    }
    if(e.target.closest('#cdUpsellAdd')){ addUpsell(); return; }
    if(t = e.target.closest('[data-hb-add]')){
      const vid = parseInt(t.dataset.hbAdd, 10);
      if(vid){ t.disabled = true; addById(vid, t); }
      return;
    }
    if(e.target.closest('#cdCheckout')){ checkout(); return; }
    if(t = e.target.closest('#cartBody [data-line]')){
      let q = +t.dataset.q;
      if(q > 5) q = 5;
      if(q < 0) q = 0;
      changeLine(+t.dataset.line, q);
      return;
    }
    if(t = e.target.closest('#thumbs [data-thumb]')){
      if(t.dataset.thumb === 'video'){ state.galleryMode = 'video'; renderGalleryMain(); }
      else { selectDesign(+t.dataset.thumb, 'gallery'); }
      return;
    }
    if(t = e.target.closest('#designSelect [data-design]')){
      selectDesign(+t.dataset.design, 'design_picker');
      return;
    }
    if(e.target.closest('#bundleList select')){ return; }
    if(t = e.target.closest('#bundleList [data-tier]')){ selectTier(+t.dataset.tier, 'bundle_card'); return; }
    if(t = e.target.closest('#collGrid [data-coll]')){
      selectDesign(+t.dataset.coll, 'collection');
      showToast(`${DESIGNS[state.design].name} selected`);
      return;
    }
    if(t = e.target.closest('#tierGrid [data-tiercard]')){
      const i = +t.dataset.tiercard;
      selectTier(i, 'bundle_section');
      if(e.target.closest('.tier-btn')) addToCart();
      return;
    }
    if(t = e.target.closest('#finalThumbs [data-final]')){ selectDesign(+t.dataset.final, 'final_picker'); return; }
    const q = e.target.closest('.faq-q');
    if(q){
      const item = q.parentElement;
      const ans = item.querySelector('.faq-a');
      const open = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o=>{
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
      });
      if(!open){
        item.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    }
  });
  document.addEventListener('keydown', function(e){
    const bundle = e.target.closest('#bundleList [data-tier]');
    const isControl = e.target.closest('select,button,input,textarea');
    if(bundle && !isControl && (e.key === 'Enter' || e.key === ' ')){
      e.preventDefault();
      selectTier(+bundle.dataset.tier, 'keyboard');
      bundle.focus();
      return;
    }
    const cur = e.target.closest('#designSelect [data-design]');
    if(!cur) return;
    if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
    e.preventDefault();
    const fwd = (e.key === 'ArrowRight' || e.key === 'ArrowDown');
    const i = +cur.dataset.design;
    const next = (i + (fwd ? 1 : -1) + DESIGNS.length) % DESIGNS.length;
    selectDesign(next, 'keyboard');
    const el = document.querySelector('#designSelect [data-design="' + next + '"]');
    if(el) el.focus();
  });
  document.addEventListener('change', function(e){
    const select = e.target.closest('#bundleList select[data-slot]');
    if(!select) return;
    const slot = +select.dataset.slot;
    state.slots[slot] = +select.value;
    if(slot === 0){ state.design = +select.value; }
    renderAll();
    trackBundleEvent('bundle_design_selected', Object.assign(bundleEventData(), {
      slot:slot+1,
      source:'bundle_select'
    }));
  });

  /* scroll / resize / safety net — attached once */
  let fxTick = false;
  window.addEventListener('scroll', ()=>{ if(!fxTick){ fxTick = true; requestAnimationFrame(()=>{ onScrollFx(); fxTick = false; }); } }, {passive:true});
  window.addEventListener('resize', onScrollFx);
  window.addEventListener('load', onScrollFx);
  setTimeout(onScrollFx, 600);
  setInterval(onScrollFx, 1200); /* safety net: keeps scroll-state UI correct even if scroll events are missed */

  /* ───────────────── INIT + THEME EDITOR SUPPORT ───────────────── */
  function init(){
    refreshData();
    clampState();
    renderAll();
    renderCart();
    buildBatch();
    videoInit();
    onScrollFx();
    fetchCart();
  }
  document.addEventListener('shopify:section:load', function(){ init(); });
  document.addEventListener('shopify:section:unload', function(){ /* state persists; next load re-renders */ });
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
